function initOrcarForm() {
	const form = document.querySelector("[data-orcar-form]");
	if (!form) {
		return;
	}

	form.addEventListener("submit", (event) => {
		event.preventDefault();

		const voltagem = form.querySelector("#voltagem");
		const quantidade = form.querySelector("#quantidade");

		if (!voltagem.value || !quantidade.value) {
			voltagem.reportValidity();
			quantidade.reportValidity();
			return;
		}

		const productName = form.dataset.productName || "";
		const whatsappNumber = form.dataset.whatsapp || "";
		const message = `Olá! Gostaria de um orçamento do climatizador ${productName}. Voltagem: ${voltagem.value}V. Quantidade: ${quantidade.value}.`;

		window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, "_blank", "noopener");
	});
}

initOrcarForm();
